import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Row from '../../../../../../common/atoms/Row';
import Anchor from '../../../../../../common/atoms/Anchor';
import Image from '../../../../../../common/atoms/Image';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/OrdersOverviewNew.style';
import { getIconPath } from '../../../../../../../utils';
import internalEndpoints from '../../../internalEndpoints';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_OVERVIEW_LABEL,
  OrderTileLabels,
  lblOverviewOrderHeading,
} from '../container/OrderTile.labels';
import globalCartItemTileLabels, {
  GLOBAL_CART_ITEM_TILE_LABELS,
  lblViewAll,
} from '../../../../../../../utils/labels/globalCartItemTile.labels';

const OrdersOverviewNew = (props) => {
  const { children, className, isNoOrdersAvailable, useRouterNavigation } = props;
  return (
    <div
      className={`${className} orders-tile-wrapper ${
        isNoOrdersAvailable ? 'no-orders-available' : 'orders-available'
      }`}
    >
      <BodyCopy component="div" className="orders-tile-heading">
        <div className="orders-tile-heading-left">
          <Image src={`${getIconPath('orders')}`} alt={'Orders Icon'} className="orders-icon" />
          <span className="orders-tile-heading-text">
            {getLabelFromCopyOrFromTranslation(
              `${ACCOUNT_OVERVIEW_LABEL}.${lblOverviewOrderHeading}`,
              OrderTileLabels
            )}
          </span>
        </div>
        <Anchor
          to={internalEndpoints.myOrderPage.link}
          asPath={internalEndpoints.myOrderPage.path}
          className="orders-tile-view-all"
          target={'_self'}
          dataLocator={'accountverview-orders-viewallcta'}
          useRouterNavigation={useRouterNavigation}
        >
          {getLabelFromCopyOrFromTranslation(
            `${GLOBAL_CART_ITEM_TILE_LABELS}.${lblViewAll}`,
            globalCartItemTileLabels
          )}
        </Anchor>
      </BodyCopy>
      <Row fullBleed className="orders-tile-main">
        {children}
      </Row>
    </div>
  );
};

OrdersOverviewNew.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isNoOrdersAvailable: PropTypes.bool,
  useRouterNavigation: PropTypes.bool,
};

OrdersOverviewNew.defaultProps = {
  className: '',
  useRouterNavigation: false,
};
export default withStyles(OrdersOverviewNew, styles);
export { OrdersOverviewNew as OrdersOverviewNewVanilla };
